import React, { useState, useEffect } from "react";
import { Text, View, StyleSheet } from "react-native";

import { Dropdown } from '../Dropdown';

import Colors from '../../constants/colors'
import Hoverable from "../../lib/Hoverable";

const MAX_WIDTH_TOOLTIP = 600;

// props
// elementHeight: height of element that calls tooltip.
// elementDimensions: dimensions of element, in particular dy, is used to know where to put tooltip on screen.
// onOutsidePress: event fired when user clicks outside of tooltip.
// text: string to show in tooltip.
const Tooltip = (props) => {
  const [show, setShow] = useState(false)

  useEffect(() => {
    setShow(props.hover)
  }, [props.hover])

  return (
    <>
      {!props.hidden ?
        <Dropdown onOutsidePress={() => setShow(false)}>
          <Dropdown.Toggle>
            <Hoverable>
              {hover => (
                setShow(hover),
                props.onChangeHover && props.onChangeHover(hover),
                props.children
              )}
            </Hoverable>
          </Dropdown.Toggle>
          <Dropdown.Floating
            isOpen={show}
            doNotBlockBackground
            animated
            startAnimation={'fadeIn'}
            endAnimation={'fadeOut'}
            zIndex={5}
          >
            <View style={styles.tooltip}>
              <Text style={{color: Colors.white, textAlign: 'center', maxWidth: MAX_WIDTH_TOOLTIP}}>{props.text}</Text>
            </View>
          </Dropdown.Floating>
        </Dropdown>
      : props.children}
    </>
  )
};

const styles = StyleSheet.create({
  tooltipText: {
    color: Colors.white,
    textAlign: 'center',
  },
  tooltip: {
    backgroundColor: '#1a2936',
    maxHeight: 300,
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderWidth: 0,
    shadowColor: Colors.dark,
    shadowOffset: { width: 3, height: 3 },
    shadowOpacity: 0.8,
    shadowRadius: 10,
    elevation: 5,
  },
  base: {
    position: 'fixed',
    top: 0
  },
})

export default Tooltip;
